const pageName = 'yourAccountPage';
const clickEvents = {
  addToCartButton: {
    pageName,
    buttonName: 'addToCart'
  },
  loginButton: {
    pageName,
    buttonName: 'login'
  },
  filterToBeShippedOrdersButton: {
    pageName,
    buttonName: 'filterToBeShippedOrders'
  },
  filterToBeDeliveredOrdersButton: {
    pageName,
    buttonName: 'filterToBeDeliveredOrders'
  },
  filterToBeReviewedOrdersButton: {
    pageName,
    buttonName: 'filterToBeReviewedOrders'
  },
  gotToReturnAndAfterSalesButton: {
    pageName,
    buttonName: 'gotToReturnAndAfterSales'
  },
  getMyOrdersButton: {
    pageName,
    buttonName: 'getMyOrders'
  },
  getMyCouponsButton: {
    pageName,
    buttonName: 'getMyCoupons'
  },
  getMyShippingAddressButton: {
    pageName,
    buttonName: 'getMyShippingAddress'
  },
  getCustomsClearanceInfoButton: {
    pageName,
    buttonName: 'getCustomsClearanceInfo'
  },
  goToSettingsButton: {
    pageName,
    buttonName: 'goToSettings'
  }
};

const loadingEvents = {
  yourAccountPage: {
    pageName,
    eventName: 'ATF'
  }
};

export default {
  clickEvents,
  loadingEvents
};
